<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_5.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">A</div>
				<div class="step_txt">
					Wash hands before testing.
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_6.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">B</div>
				<div class="step_txt">
					<div class="pad_bot">
						Check <span class="col-red">Expiration Date</span> on the package. 
					</div>
					<div class="pad_bot col-red">
						Do not use expired test kit!
					</div>
					<div class="pad_bot">
						For most current shelf-life information of this test lot, please refer to the following link:<br />
						<a href="http://www.fda.gov/covid-tests" style="color: #652900;font-weight: bold;text-decoration: underline;">http://www.fda.gov/covid-tests</a>
					</div>
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_7.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">C</div>
				<div class="step_txt">
					<ul>
						<li>Remove the test cassette from the pouch and place it on a clean, &nbsp;flat surface.</li>
						<li>Insert the tube in the pre-made hole on the back of the kit box.</li>
						<li>Remove the foil from the top of the tube.</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="btn_box">
			<van-button
				type="primary"
				block
				round
				color="linear-gradient(to right, #a74af2, #5949f2)"
				@click="goStepThree"
			>
				Next
			</van-button>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			//
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		//
	},
	mounted() {
		let that = this;
		that.$nextTick(() => {
			setTimeout(() => {
				window.scrollTo(0, 0);
			}, 50);
		});
	},
	watch: {
		//
	},
	methods: {
		goStepThree() {
			this.$router.push({path:'/stepthree'});
		},
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.container{
	/* position: absolute;
	height: 100%;
	background-color: #fbfbfb; */
}
.step_box{
	position: relative;
	padding: 0.32rem 0.32rem 0 0.32rem;
}
.step_box .step_el{
	background-color: #ffffff;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
	position: relative;
	border: 1px solid #E9E9E9;
}
.step_box .step_el:last-child{
	margin-bottom: 0;
}
/* .step_box, .btn_box{background-color: #fbfbfb;} */
.step_box{padding-bottom: 0.64rem !important;}
/*步骤下说明文字*/
.step_txt{
	padding: 0.533rem 0.5rem 0.427rem 0.5rem;
	color: #333333;
}
.step_box img{
	width: 100%;
	height: auto;
}
.step_box .step_el{
	position: relative;
}
.step_box .step_el:last-child{
	padding-bottom: 0;
}
.step_box .step_el .tit{
	position: absolute;
	top: 0.32rem;
	left: 0.32rem;
	font-size: 0.533rem;
	color: #333333;
	font-weight: bold;
}
.btn_box{padding:0rem 0.9rem 1.107rem 0.9rem;}
.step_box img, .btn_box img{width: 100%;}

.step_txt .pad_bot{
	padding-bottom: 0.1rem;
}
ul li{
	padding: 0 0 0.1rem 0;
}
ul li:last-child{
	padding-bottom: 0;
}

>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}
</style>
